import { Stack, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React from 'react';
const HomeNewsCard = (props) => {
    return (
        <Card sx={{
            // 'display': 'block',
            // 'width': '30vw',
            // 'transitionDuration': '0.3s',
            'height': '65vh',
            justifyContent: 'space-between',
            'borderRadius': '15px',
            'padding': '30px',
            // 'width': 'auto',
            // 'boxShadow': '0px 16px 40px rgba(112, 144, 176, 0.2)',
            boxShadow: 'none',

            display: 'flex', flexDirection: 'column', minWidth: { lg: '275px', sm: '240px', xs: '200px' }, minHeight: { lg: '180px', sm: '160px', xs: '150px' },
            'backgroundColor': 'rgba(255, 255, 255, 0.05)'
        }}>
            <div>

                <CardMedia
                    sx={{ 'borderRadius': '15px' }}
                    width='auto'
                    height='150vh'
                    component="img"
                    style={{ 'objectFit': 'cover', 'maxHeight': 200, justifyContent: "center", display: "flex" }}
                    alt="green iguana"
                    src={props.source}
                />


                <CardContent style={{ alignItems: 'flex-start', flexDirection: 'column', padding: '0px' }}>
                    <Typography variant="h4" component="div" sx={{
                        mt: 1.5,
                        'display': '-webkit-box',
                        'WebkitBoxOrient': 'vertical',
                        'WebkitLineClamp': '3',
                        'overflow': 'hidden',
                        fontWeight: '700', fontSize: { lg: '22px', sm: '20px', xs: '18px' }, color: '#90CAF9'
                    }}>
                        {props.title}
                    </Typography>
                    <Typography sx={{ mb: 1.5, fontSize: { lg: '18px', sm: '16px', xs: '14px' }, }} color="#86868b">
                        {props.author}
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontSize: { lg: '16px', sm: '14px', xs: '12px' }, 'color': "#fff"
                        , 'display': '-webkit-box',
                        'WebkitBoxOrient': 'vertical',
                        'WebkitLineClamp': '3',
                        'overflow': 'hidden'
                    }}>
                        {props.description}
                    </Typography>
                </CardContent>
            </div>
            <CardActions sx={{
                mt: 1.5, display: 'flex', alignItems: 'left', justifyContent: 'space-between', 'padding': '0px'

            }}>
                <Stack direction='row' alignItems='center' style={{ cursor: 'pointer' }} onClick={() => { window.open(props.url) }} >
                    <h4 style={{ margin: '0px', color: '#1976D2', 'textDecoration': 'none', 'padding': '0px' }} >Learn more</h4>
                    <ChevronRightIcon sx={{ color: '#06c' }} />
                </Stack>
            </CardActions>
        </Card >)
}
export default HomeNewsCard